import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  Doddle,
  DoddleCollection,
  SubscriblyPost,
  SubscriblyPostPayload,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class PostApiService {
  constructor(private http: HttpClient) {}

  getDoddles(
    workspaceId: string,
    fromDate?: string,
    toDate?: string,
    includeChannels = true,
  ): Observable<DoddleCollection> {
    let params = {};
    if (fromDate && toDate) {
      params = new HttpParams()
        .set('publishFromDate', fromDate)
        .set('publishToDate', toDate);
    }
    return this.http.get<DoddleCollection>(
      `/workspace/${workspaceId}/doddles?includeMedia${this.channelQuery(includeChannels)}`,
      { params },
    );
  }

  getDoddleById(doddleId: string, includeChannels = true): Observable<Doddle> {
    return this.http.get<Doddle>(
      `/doddle/${doddleId}?includeMedia${this.channelQuery(includeChannels)}`,
    );
  }

  createDoddle(
    payload: Partial<Doddle>,
    includeChannels = true,
  ): Observable<Doddle> {
    return this.http.post<Doddle>(
      `/doddle?includeMedia${this.channelQuery(includeChannels)}`,
      payload,
    );
  }

  updateDoddle(
    postId: string,
    payload: Partial<Doddle>,
    patchPosts = false,
    includeChannels = true,
  ): Observable<Doddle> {
    return this.http.patch<Doddle>(
      `/doddle/${postId}?includeMedia${this.channelQuery(includeChannels)}`,
      payload,
      { params: { patchPosts } },
    );
  }

  deleteDoddle(doddleId: string): Observable<Doddle> {
    return this.http.delete<Doddle>(`/doddle/${doddleId}`);
  }

  getSubscriblyPosts(doddleId: string): Observable<SubscriblyPost[]> {
    return this.http.get<SubscriblyPost[]>(
      `/posts/${doddleId}?includeValidation`,
    );
  }

  createSubscriblyPost(
    payload: SubscriblyPostPayload,
  ): Observable<SubscriblyPost> {
    return this.http.post<SubscriblyPost>(`/post?includeValidation`, payload);
  }

  deleteSubscriblyPost(subscriblyPostId: string): Observable<SubscriblyPost> {
    return this.http.delete<SubscriblyPost>(`/post/${subscriblyPostId}`);
  }

  updateSubscriblyPost(
    subscriblyPostId: string,
    payload: Partial<SubscriblyPost>,
  ): Observable<SubscriblyPost> {
    return this.http.patch<SubscriblyPost>(
      `/post/${subscriblyPostId}?includeValidation`,
      payload,
    );
  }

  private channelQuery(includeChannels: boolean): string {
    return includeChannels ? '&includeChannels' : '';
  }
}
